<h1>Are you sure?</h1>
<mat-dialog-actions align="right">
    <button mat-button mat-dialog-close="{{true}}">Delete</button>
    <button mat-button mat-dialog-close="{{false}}">Cancel</button>
</mat-dialog-actions>
